import React, { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../AuthProvider.js';  
 
const Dashboard = () => {
    const { userInfo, isLoading } = useContext(AuthContext);
    console.log(userInfo);
     
    const formatExpiryDate = (dateString) => {
        if (!dateString) return 'N/A';
        
        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    };
    
    // Check if the subscription has expired
    const isSubscriptionExpired = () => {
        if (!userInfo?.expire_date) return false;
        
        const expireDate = new Date(userInfo.expire_date);
        const today = new Date();
        
        return expireDate < today;
    };

    // Check if expiry date is within 30 days
    const isExpiryWithin30Days = () => {
        if (!userInfo?.expire_date) return false;
        
        const expireDate = new Date(userInfo.expire_date);
        const today = new Date();
        
        // Calculate the difference in milliseconds and convert to days
        const differenceInTime = expireDate.getTime() - today.getTime();
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);
        
        return differenceInDays <= 30;
    };

    // Determine whether to show the alert
    const shouldShowAlert = () => {
        return userInfo?.expire_date && (isSubscriptionExpired() || isExpiryWithin30Days());
    };

    // Determine the alert class based on expiration status
    const getAlertClass = () => {
        return isSubscriptionExpired() ? 'alert-danger' : 'alert-warning';
    };

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-sm-6 col-xl">
                        <div className="card box-margin">
                            <div className="card-body">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h6 className="text-uppercase font-14">
                                            Api Hits
                                        </h6>

                                        <span className="text-dark mb-0" style={{ fontSize: '22px' }}>
                                            2345
                                        </span>
                                    </div>

                                    <div className="col-auto">
                                        <div className="icon">
                                            <img src="../admin_codebase/img/bg-img/cloud-api.png" className="img-fluid" width="45" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-xl">
                        <div className="card box-margin">
                            <div className="card-body">
                                <div className="row align-items-center justify-content-between">
                                    <div className="col">
                                        <h6 className="font-14 text-uppercase">
                                            Ticket Raised
                                        </h6>
                                        <span className="font-24 text-dark mb-0">
                                            663.5
                                        </span>
                                    </div>
                                    <div className="col-auto">
                                        <div className="icon">
                                            <img src="/admin_codebase/img/bg-img/customer.png" className="img-fluid" width="50" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-sm-6 col-xl">
                        <div className="card box-margin">
                            <div className="card-body">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h6 className="font-14 text-uppercase">
                                            Lead Count
                                        </h6>
                                        <div className="row align-items-center no-gutters">
                                            <div className="col-auto">
                                                <span className="font-24 text-dark mr-2">
                                                    84.5%
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-auto">
                                        <div className="icon">
                                            <img src="/admin_codebase/img/bg-img/customer.png" alt="" className="img-fluid" width="50" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-sm-6 col-xl">
                        <div className="card box-margin">
                            <div className="card-body">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <h6 className="font-14 text-uppercase">
                                            ROI
                                        </h6>
                                        <span className="font-24 text-dark">
                                            78%
                                        </span>
                                    </div>
                                    <div className="col-auto">
                                        <div className="icon">
                                            <img src="/admin_codebase/img/bg-img/customer.png" alt="" className="img-fluid" width="50" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                {/* Only show subscription message if within 30 days of expiry or already expired */}
                {shouldShowAlert() && (
                    <div className="col-md-12" style={{ marginBottom: '10px', marginTop: '-15px' }}>
                        <div className={`alert ${getAlertClass()} d-flex align-items-center`} role="alert">
                            <i className="bx bx-info-circle me-2" style={{ fontSize: '20px' }}></i>
                            <div>
                                Your subscription {isSubscriptionExpired() ? 'has expired' : 'is about to expire'} on <strong>{formatExpiryDate(userInfo.expire_date)}</strong>. 
                                <a href="/customer/upgrade" className="alert-link"> {isSubscriptionExpired() ? 'Renew now' : 'Upgrade now'}</a> to continue enjoying our services.
                            </div>
                        </div>
                    </div>
                )}

                <div className="row" style={{ marginBottom: 5 }}>
                    <div className="col-12">
                        <div className="card height-card box-margin">
                            <div className="row justify-content-between" style={{ height: 450 }}>
                                <div className="col-md-7 d-flex" style={{ marginTop: 70, paddingLeft: 40 }}>
                                    <div className="ps-4">
                                        <h4 className="text-dark">Hey There {userInfo ? `${userInfo.fname} ${userInfo.lname}` : ''}!</h4>
                                        <h3 className="pb-3">Aignt Welcomes you back.</h3>
                                        {/* Show the subscription status only if within 30 days of expiry or already expired */}
                                        {userInfo && userInfo.expire_date && isExpiryWithin30Days() && (
                                            <p className={isSubscriptionExpired() ? "text-danger" : "text-warning"}>
                                                Your subscription {isSubscriptionExpired() ? 'expired on' : 'is valid until'} {formatExpiryDate(userInfo.expire_date)}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-5 d-flex justify-content-end">
                                    {/* <img src="../admin_codebase/img/brainstorming.png" className="img-fluid" alt="..." width="400" /> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Dashboard;